module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-07.c8a42cc9.jpg";